import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Exclude, Expose } from 'class-transformer';
import { IsUUID } from 'class-validator';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import { ModelDto } from '../../model/dto/model.dto';
import { BuilderDto } from '../../builder/dto/builder.dto';
import { RepairDto } from '../../repair/dto/repair.dto';
import { ScheduledEmailsDailyRepairReminderInterface } from '../interfaces/scheduled-emails-daily-repair-reminder.interface';
import { RepairTypeEnum } from '../../repair/enums/repair-type.enum';
import { JobInterface } from 'src/modules/job/interfaces/job.interface';
import { SubdivisionInterface } from 'src/modules/subdivision/interfaces/subdivision.interface';

@Exclude()
export class ScheduledEmailsDailyRepairReminderDto
  extends CommonEntityDto
  implements ScheduledEmailsDailyRepairReminderInterface
{
  supervisorFullName!: string;

  @ApiProperty({
    title: 'Supervisor email',
  })
  @Expose()
  supervisorEmail!: string;

  @ApiPropertyOptional({
    type: 'boolean',
    description: 'job repair is ready to book?',
  })
  @Expose()
  readyToBook!: boolean;

  @ApiProperty({
    format: 'uuid',
    title: 'Regional Manager ID',
    description:
      'The ID of the regional manager associated with this jobRepair',
  })
  @IsUUID()
  @Expose()
  managerUserId!: string;

  @ApiProperty({
    title: 'Region manager email',
  })
  @Expose()
  managerEmail!: string;

  @ApiProperty({
    format: 'uuid',
    title: 'Model ID',
    description: 'The ID of the Model associated with this jobRepair',
  })
  @IsUUID()
  @Expose()
  modelId!: string;

  @ApiProperty({
    format: 'uuid',
    title: 'Subdivision ID',
    description: 'The ID of the Subdivision associated with this jobRepair',
  })
  @IsUUID()
  @Expose()
  subdivisionId!: string;

  @ApiProperty({
    format: 'uuid',
    title: 'Builder ID',
    description: 'The ID of the Builder associated with this jobRepair',
  })
  @IsUUID()
  @Expose()
  builderId!: string;

  @ApiProperty({
    format: 'uuid',
    title: 'Supervisor User ID',
    description: 'The ID of the supervisor user associated with this jobRepair',
  })
  @IsUUID()
  @Expose()
  supervisorUserIds!: string;

  @ApiProperty({
    format: 'uuid',
    title: 'Job ID',
    description: 'The ID of the job associated with this jobRepair',
  })
  @IsUUID()
  @Expose()
  jobId!: string;

  @ApiProperty({
    format: 'uuid',
    title: 'REpair ID',
    description: 'The ID of the repair associated with this jobRepair',
  })
  @IsUUID()
  @Expose()
  repairId!: string;

  @ApiProperty({
    title: 'Job lot',
    description: 'The job lot associated with this jobRepair',
  })
  @Expose()
  jobLot!: string;

  @ApiProperty({
    title: 'Job lot',
    description: 'The job block associated with this jobRepair',
  })
  @Expose()
  jobBlock!: string;

  @ApiProperty({
    title: 'Model name',
    description: 'The model name associated with this jobRepair',
  })
  @Expose()
  modelName!: string;

  @ApiProperty({
    title: 'Subdivision name',
    description: 'The subdivision name associated with this jobRepair',
  })
  @Expose()
  subdivisionName!: string;

  @ApiProperty({
    title: 'Buider name',
    description: 'The builder name associated with this jobRepair',
  })
  @Expose()
  builderName!: string;

  @ApiProperty({
    title: 'Supervisor phone',
    description: 'The supervisor phone associated with this jobRepair',
  })
  @Expose()
  supervisorPhoneNumber!: string;

  @ApiProperty({
    title: 'Address1',
  })
  @Expose()
  address1!: string;

  @ApiProperty({
    title: 'Address2',
  })
  @Expose()
  address2!: string;

  @ApiProperty({
    title: 'City',
  })
  @Expose()
  city!: string;

  @ApiProperty({
    title: 'State',
  })
  @Expose()
  state!: string;

  @ApiProperty({
    title: 'Zip code',
  })
  @Expose()
  zip!: string;

  @ApiProperty({
    title: 'Po Amount',
  })
  @Expose()
  poAmount!: string;

  @ApiProperty({
    title: 'Job repair description',
  })
  @Expose()
  jobRepairDescription!: string;

  @ApiProperty({
    title: 'Subdivision builder supervisors id',
  })
  @Expose()
  subdivisionBuilderSupervisorId!: string;

  @ApiProperty({
    title: 'Subdivision builder supervisors email',
  })
  @Expose()
  subdivisionBuilderSupervisorEmail!: string;

  @ApiPropertyOptional({
    type: 'enum',
    enum: RepairTypeEnum,
    title: 'Associated repair type',
    description: 'The repair type associated with this jobRepair',
  })
  @Expose()
  repairType!: RepairTypeEnum;

  @ApiPropertyOptional({
    type: () => ModelDto,
    title: 'Associated Model',
    description: 'The model associated with this jobRepair',
  })
  @Expose()
  model?: ModelDto;

  @ApiPropertyOptional({
    type: () => BuilderDto,
    title: 'Associated Builder',
    description: 'The builder associated with this jobRepair',
  })
  @Expose()
  builder?: BuilderDto;

  @ApiPropertyOptional({
    type: () => RepairDto,
    title: 'Associated repair',
    description: 'The repair associated with this jobRepair',
  })
  @Expose()
  repair?: RepairDto;
}
